import { env } from '@/config/env.ts'
import type { ContractConfig } from './contract.types.ts'

export function getContractConfig(): ContractConfig {
  return {
    address: env.contractAddress as `0x${string}`,
    chainId: env.chainId,
  }
}

export const contractConfig = getContractConfig()
